<header>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-6">
                <img src="assets/images/NSEICC.png" routerLink="" class="logo" />
            </div>

            <div class="col-lg-6 col-md-6 col-6">
                <div class="row mt-xs-1 mb-xs-1 justify-content-end">
                    <div class="col-lg-2 mt-2">
                        <a class="contact" routerLink="/contact">Contact Us</a>
                    </div>
                    <div class="col-lg-2 mt-2">
                        <div class="d-flex justify-content-end">
                            <div class="dropdown changepass">
                                <a href="" class="mb-0 dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <div class="ml-2">
                                        <div class="initial">
                                            {{user?.loginId && user?.loginId[0]}}
                                        </div>
                                    </div>
                                    <span class="caret"></span>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <div class="d-flex dropdown-item">
                                        <div class="nowrap mr-2">
                                            <div class="mb-0 nowrap userdropdown">
                                                <p>{{user?.loginId}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <a class="dropdown-item pointer" (click)="profile()">Profile</a> -->
                                    <a class="dropdown-item pointer" (click)="settings()">User Settings</a>
                                    <!-- <a class="dropdown-item pointer" (click)="changePassword()">Change Password</a> -->
                                    <a class="dropdown-item pointer" (click)="logout()">Logout</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="seperator">
        <div class="col-lg-1 seperator1"></div>
        <div class="col-lg-2 seperator2"></div>
        <div class="col-lg-4 seperator3"></div>
        <div class="col-lg-5 seperator4"></div>
    </div>
</header>